// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"719":"65077de8","829":"9510d617","919":"6c055c69"}[chunkId] + ".chunk.js";
};